import { Client } from "../../../client";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { API_CLOSE_OUT_PROPERTY } from "../../../config/api";
import { getInvestment } from "./getInvestment";

export const closeOutProperty = createAsyncThunk(
  "property/closeOut",
  async (payload, { dispatch, rejectWithValue }) => {
    try {
      const response = await Client({
        method: "PUT",
        path: API_CLOSE_OUT_PROPERTY + payload?.id,
      });

      toast.success("Investment has been successfully closed");
      payload?.cb();

      return response?.data;
    } catch (error) {
      // const msg = proccessErrorMessage(error);
      toast.error(error);
      payload?.failed();
      return rejectWithValue(error.message);
    }
  }
);
